import React from 'react';
import { Box, Skeleton, Paper } from '@mui/material';
import { variants } from '../../../variants/variants';
import { navigations } from '../utility/navigations';

const SkeletonProfileActions = () => (
  <Box
    component={Paper}
    elevation={0}
    sx={{
      backgroundColor: variants.boxBackground.PROFILE_CARD,
      p: 1,
      borderRadius: variants.boxRadius.SIDEBAR,
      border: 1,
      borderColor: 'divider',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <Skeleton variant='circular' width={40} height={40} sx={{ cursor: 'default' }} />
      <Box sx={{ ml: 1, flexGrow: 1 }}>
        <Skeleton variant='text' width='50%' height={20} />
        <Skeleton variant='text' width='70%' height={15} />
      </Box>
      <Skeleton variant='rounded' width={20} height={20} />
    </Box>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Skeleton variant='rounded' width={'90%'} height={30} />
    </Box>
  </Box>
);

export default SkeletonProfileActions;
